import * as t from '../types'
import config from 'config'
import React from 'react'
import styled from 'styled-components'
import B2cSwitch from 'theme/atoms/B2cSwitch'
import Link from 'theme/atoms/Link'
import useTranslations from 'hooks/useTranslations'
import usePageContext from 'hooks/usePageContext'
import theme from 'theme'
import priceStr from 'utils/priceString'
import withTranslations from '../withTranslations'
import useAccount from 'hooks/account/useAccount'

export function getPageType(pageType?: t.PageType) {
  const pageContext = usePageContext()
  if (pageType) return pageType
  if (pageContext?.type === 'Product') return 'Product'
  if (pageContext?.type === 'Category') return 'Listing'
  if (pageContext?.type === 'Series') return 'Series'
  if (pageContext?.type === 'Cart') return 'Cart'
  if (pageContext?.type === 'Homepage') return 'Listing'
  if (pageContext?.type === 'Other') return 'Other'
  return ''
}

export function mapPricesToObject(
  prices: t.ProductPriceDefinition
): t.mappedPrices {
  const newPriceObj = {
    net: { piece: {}, pack: {} },
    gross: { piece: {}, pack: {} }
  }
  Object.keys(prices).map((key) => {
    if (key.includes('Net')) {
      const searchkey = key.replace('Net', '')
      if (searchkey.includes('piece') || searchkey.includes('Piece')) {
        newPriceObj.net.piece[
          searchkey.replace('piece', '').replace('Piece', '')
        ] = prices[key]
      } else if (key.includes('pack') || searchkey.includes('Pack')) {
        newPriceObj.net.pack[
          searchkey.replace('pack', '').replace('Pack', '')
        ] = prices[key]
      } else {
        newPriceObj.net[key.replace('Net', '')] = prices[key]
      }
    } else if (key.includes('Gross')) {
      const searchkey = key.replace('Gross', '')
      if (key.includes('piece') || searchkey.includes('Piece')) {
        newPriceObj.gross.piece[
          searchkey.replace('piece', '').replace('Piece', '')
        ] = prices[key]
      } else if (key.includes('pack') || searchkey.includes('Pack')) {
        newPriceObj.gross.pack[
          searchkey.replace('pack', '').replace('Pack', '')
        ] = prices[key]
      } else {
        newPriceObj.gross[key.replace('Gross', '')] = prices[key]
      }
    } else {
      newPriceObj[key] = prices[key]
    }
  })
  return newPriceObj
}

export const reductionNumber = (prices, logic) => {
  const channel = useAccount().channel

  if (
    reduction(
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].Price,
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].PseudoPrice
    ) !== '' &&
    reduction(
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].Price,
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].PseudoPrice
    ) !== '--∞ %'
  ) {
    return reduction(
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].Price,
      prices[channel === 'b2b' ? 'net' : 'gross'][logic].PseudoPrice
    )
  } else return null
}

export const reduction = (
  price: number | string,
  pseudoPrice: number | string
) => {
  price = typeof price === 'string' ? parseFloat(price) : price
  pseudoPrice =
    typeof pseudoPrice === 'string' ? parseFloat(pseudoPrice) : pseudoPrice
  const reduction = 1 - price / pseudoPrice
  if (parseInt((reduction * 100).toString()) === 0) return ''

  return (
    '-' +
    reduction.toLocaleString(config.i18n.locale, {
      style: 'percent'
    })
  )
}

export function inclTaxPDP(price, logic, unit, fullPrice?) {
  const t = useTranslations<'prices'>()

  let finalPrice = 'NaN'

  if (typeof price === 'number') {
    finalPrice = priceStr(price)
  }
  if (typeof price === 'string') {
    finalPrice = price
  }

  const priceInfo = (
    <PriceInfo>
      <B2cSwitch.B2B>
        <span className="excl-delivery">
          ({t('incl_tax')} {finalPrice}{' '}
          {t('excl_delivery_costs_with_link', {
            DELIVERYCOSTS: '-',
            __transformers: {
              DELIVERYCOSTS: (_, vars) => (
                <LinkText>
                  {
                    <Link to={vars.DELIVERYCOSTS_link}>
                      {vars.DELIVERYCOSTS_label}
                    </Link>
                  }
                </LinkText>
              )
            }
          })}
          )
        </span>
      </B2cSwitch.B2B>
      <B2cSwitch.B2C>
        <span className="excl-delivery">
          ({t('incl_tax')}{' '}
          {t('excl_delivery_costs_with_link', {
            DELIVERYCOSTS: '-',
            __transformers: {
              DELIVERYCOSTS: (_, vars) => (
                <LinkText>
                  {
                    <Link to={vars.DELIVERYCOSTS_link}>
                      {vars.DELIVERYCOSTS_label}
                    </Link>
                  }
                </LinkText>
              )
            }
          })}
          )
        </span>
      </B2cSwitch.B2C>
    </PriceInfo>
  )
  if (logic === 'piece') {
    return (
      <PDPDetails data-cy-state="show-piece-price-subtext">
        {t('per_piece_text')}
        &#160;
        {unit.unitName}
        {unit.purchaseUnit === 1 && (
          <>
            ,&#160;
            {priceInfo}
          </>
        )}{' '}
        <B2cSwitch.B2B>
          {fullPrice?.net.referencePriceString &&
            '; ' + fullPrice.net.referencePriceString}
        </B2cSwitch.B2B>
        <B2cSwitch.B2C>
          {fullPrice?.gross.referencePriceString &&
            '; ' + fullPrice.gross.referencePriceString}
        </B2cSwitch.B2C>
      </PDPDetails>
    )
  } else if (logic === 'pack') {
    return (
      <PDPDetails data-cy-state="show-pack-price-subtext">
        {unit.purchaseUnit}
        &#160;
        {unit.unitName}
        &#160;/&#160;
        {unit.packUnit}
        ,&#160;
        {priceInfo}
      </PDPDetails>
    )
  } else if (logic === 'series') {
    return (
      <PDPDetails data-cy-state="show-pack-price-subtext">
        {t.asText(false, 'sku_piece_price_label') + ' '}
        {priceInfo}
      </PDPDetails>
    )
  } else {
    throw new Error(
      'Logic or Unit invalid for inclTax function at PriceCalculation'
    )
  }
}

const PDPDetails = styled.div`
  ${theme.ty('r-s')}
`

export function inclTaxListing(
  unit,
  net,
  gross,
  cheapestPrice,
  price,
  page,
  specialType
) {
  const t = useTranslations<'prices'>()
  const netReferencePrice = price.net.referencePriceString
  const grossReferencePrice = price.gross.referencePriceString
  const productCheapestPackPriceNet = price.net.pack.productCheapestPrice
  const productCheapestPackPriceGross = price.gross.pack.productCheapestPrice
  const strikePrice =
    price.net.piece.PseudoPrice !== 0 || price.gross.piece.PseudoPrice !== 0

  return (
    <ListingDetails
      $strikePrice={
        strikePrice &&
        (specialType === 'HighlightProduct' ||
          (!cheapestPrice && page === 'Listing'))
      }
    >
      {unit?.purchaseUnit > 1 && (
        <div data-cy-state="has-pack-price" className="detail-wrapper">
          {cheapestPrice && page === 'Listing' && (
            <div data-cy-state="from" className="from">
              {t.asText(false, 'from') + ' '}
            </div>
          )}
          <div className="piece-price">
            <B2cSwitch.B2B>
              {productCheapestPackPriceNet
                ? cheapestPrice && specialType !== 'HighlightProduct'
                  ? priceStr(productCheapestPackPriceNet)
                  : priceStr(price.net.pack.Price)
                : priceStr(net.Price)}
            </B2cSwitch.B2B>
            <B2cSwitch.B2C>
              {productCheapestPackPriceGross
                ? cheapestPrice && specialType !== 'HighlightProduct'
                  ? priceStr(productCheapestPackPriceGross)
                  : priceStr(price.gross.pack.Price)
                : priceStr(gross.Price)}
            </B2cSwitch.B2C>
            {' / '}
            {price.productCheapestMinSkuContentCount &&
            specialType !== 'HighlightProduct'
              ? price.productCheapestMinSkuContentCount
              : unit.purchaseUnit}{' '}
            {price.productCheapestMinSkuContentUnit &&
            specialType !== 'HighlightProduct'
              ? price.productCheapestMinSkuContentUnit
              : unit.unitName}
          </div>
        </div>
      )}
      {netReferencePrice && (
        <div data-cy-state="base-price" className="base-price">
          <B2cSwitch.B2B>{netReferencePrice}</B2cSwitch.B2B>
          <B2cSwitch.B2C>{grossReferencePrice}</B2cSwitch.B2C>
        </div>
      )}
    </ListingDetails>
  )
}

const LinkText = styled.span`
  text-decoration: underline;
`

const ListingDetails = styled.div<{ $strikePrice: boolean }>`
  display: flex;
  flex-direction: column;
  > .detail-wrapper {
    display: flex;
    > .from {
      margin-right: ${theme.spacing('xxs')};
      color: ${theme.colors.shade.b2};
    }
    .piece-price {
      color: ${theme.colors.shade.b2};
      > span  {
        ${(p) => p.$strikePrice && `color: ${theme.colors.accent.red};`}
      }
    }
  }
  > .base-price > span {
    color: ${theme.colors.shade.b2};
  }
`

export const customTailorPrice = (price, variant, customTailor) => {
  const isCustomTailorConfigured =
    customTailor.data.brink && customTailor.data.shape && customTailor.data.size
  if (isCustomTailorConfigured) {
    return priceStr(customTailor.getSinglePrice(price, variant))
  } else return priceStr(price)
}

export const inclEcoTax = (price, amount, pageType) => {
  const t = useTranslations<'prices'>()
  return (
    <EcoTax data-cy-state="eco-tax" $pageType={pageType}>
      <B2cSwitch.B2B>
        {price.net.ecoTax &&
          t('eco_tax', {
            ecoTax: priceStr((price.net.ecoTax || 0) * amount)
          })}
      </B2cSwitch.B2B>
      <B2cSwitch.B2C>
        {price.gross.ecoTax &&
          t('eco_tax', {
            ecoTax: priceStr((price.gross.ecoTax || 0) * amount)
          })}
      </B2cSwitch.B2C>
    </EcoTax>
  )
}

export const inclSeriesWidget = (
  unit,
  referencePriceNetString,
  referencePriceGrossString
) => {
  const t = useTranslations<'prices'>()
  return (
    <SeriesWidget>
      {unit.unitName && (
        <span data-cy-state="has-reference-unit">
          {t('series_per_piece_label', {
            unit: unit.unitName
          })}
        </span>
      )}
      {referencePriceNetString && (
        <span data-cy-state="has-reference-baseprice">
          {',  '}
          <B2cSwitch.B2B>{referencePriceNetString}</B2cSwitch.B2B>
          <B2cSwitch.B2C>{referencePriceGrossString}</B2cSwitch.B2C>
        </span>
      )}
    </SeriesWidget>
  )
}

const SeriesWidget = styled.div`
  > span {
    color: ${theme.colors.shade.b2};
    ${theme.ty('r-xs')}
  }
`

export const PriceTo = withTranslations(function PriceTo() {
  const t = useTranslations<'prices'>()
  return t('to')
})

export const PriceExclTax = withTranslations(function PriceExclTax() {
  const t = useTranslations<'prices'>()
  return t.asText(false, 'excl_tax')
})

const EcoTax = styled.div<{ $pageType: t.PageType }>`
  ${(p) => p.$pageType === 'Cart' && `color: ${theme.colors.shade.b2};`}
`
const PriceInfo = styled.span``
